import { useStore as _useStore, createStore } from 'vuex'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { plugins } from './plugins'
import { state } from './state'

import type { InjectionKey } from 'vue'
import type { Store } from 'vuex'
import type { State } from './state'

export const storeInjectionKey: InjectionKey<Store<State>> = Symbol()

export const store = createStore({
  state,
  getters,
  mutations,
  actions,
  plugins,
})

if (import.meta.hot) {
  import.meta.hot.accept(
    ['./actions', './getters', './mutations'],
    async () => {
      store.hotUpdate({
        actions: (await import('./actions')).actions,
        getters: (await import('./getters')).getters,
        mutations: (await import('./mutations')).mutations,
      })
    }
  )
}

export const useStore = (): Store<State> => _useStore(storeInjectionKey)
